import React, { useRef, useState } from 'react';

const AudioPlayer = ({ src, title, onLoad }) => {
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const [volume, setVolume] = useState(1);
    const [muted, setMuted] = useState(false);

    const fmt = (s) => `${Math.floor(s / 60)}:${Math.floor(s % 60).toString().padStart(2, '0')}`;

    const togglePlay = () => {
        if (isPlaying) { audioRef.current.pause(); } else { audioRef.current.play(); }
        setIsPlaying(!isPlaying);
    };

    const handleEnded = () => { setIsPlaying(false); setCurrentTime(0); };

    const handleVolume = (e) => {
        const v = parseFloat(e.target.value);
        audioRef.current.volume = v;
        setVolume(v);
        setMuted(v === 0);
    };

    const toggleMute = () => {
        const newMuted = !muted;
        audioRef.current.muted = newMuted;
        setMuted(newMuted);
    };

    return (
        <div className="custom-audio-player">
            <audio
                ref={audioRef}
                src={src}
                onTimeUpdate={() => setCurrentTime(audioRef.current.currentTime)}
                onLoadedData={() => { setDuration(audioRef.current.duration); onLoad && onLoad(); }}
                onEnded={handleEnded}
            />
            <div className="audio-icon-wrap">
                <i className="fas fa-music"></i>
            </div>
            <div className="audio-body">
                <div className="audio-title">{title || 'Audio'}</div>
                <div className="audio-controls">
                    <button className="audio-play-btn" onClick={togglePlay}>
                        <i className={`fas ${isPlaying ? 'fa-pause' : 'fa-play'}`}></i>
                    </button>
                    <input
                        type="range"
                        className="audio-progress"
                        min="0"
                        max={duration || 0}
                        value={currentTime}
                        step="0.1"
                        onChange={(e) => { audioRef.current.currentTime = e.target.value; setCurrentTime(e.target.value); }}
                    />
                    <span className="audio-time">{fmt(currentTime)} / {fmt(duration)}</span>
                </div>
                <div className="audio-volume-row">
                    <button className="audio-mute-btn" onClick={toggleMute}>
                        <i className={`fas ${muted || volume === 0 ? 'fa-volume-mute' : volume < 0.5 ? 'fa-volume-down' : 'fa-volume-up'}`}></i>
                    </button>
                    <input
                        type="range"
                        className="audio-volume"
                        min="0"
                        max="1"
                        step="0.05"
                        value={muted ? 0 : volume}
                        onChange={handleVolume}
                    />
                </div>
            </div>
        </div>
    );
};

export default AudioPlayer;
